/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Confirm_Total_LabelInputs */



/**
* | output |
* | --- |
* | "Total Cost:" |
*
* @param {Embed_Captions_Confirm_Total_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_total_label = /** @type {((inputs?: Embed_Captions_Confirm_Total_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Total_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cout total :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtkosten:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Costo totale:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общая стоимость:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Costo total:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总成本：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計費用:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल लागत:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Custo total:")
	return /** @type {LocalizedString} */ ("Total Cost:")
});